import onAssetApplyDlg from './onAssetApplyDlg.js'        // 资产申请
import onAssetTransferDlg from './onAssetTransferDlg.js'  // 资产转移
import onAssetReturnDlg from './onAssetReturnDlg.js'      // 资产返库
import onAssetCompensateDlg from './onAssetCompensateDlg.js'      // 资产赔偿
import onAssetScrapDlg from './onAssetScrapDlg.js'        // 资产报废
import onAssetSellDlg from './onAssetSellDlg.js'        // 资产变卖
import onReturnedWarehouseDlg from './onReturnedWarehouseDlg.js'        // 物资返库申请单
import onStandardChangeDlg from './onStandardChangeDlg.js'        // 标准数值变更
import onAssetMainDlg from './onAssetMainDlg.js'        // 资产维修单

const supplyAssetMan = {
  namespaced: true,
  modules: {
    onAssetApplyDlg,
    onAssetTransferDlg,
    onAssetReturnDlg,
    onAssetCompensateDlg,
    onAssetScrapDlg,
    onAssetSellDlg,
    onReturnedWarehouseDlg,
    onStandardChangeDlg,
    onAssetMainDlg
  }
}

export default supplyAssetMan
